<template>
    <ds-table
        :data="offersDetails"
        :heads="heads"
        spacer
        :paginate="false"
        :max-items="offersDetails.length"
    >
        <template v-slot:name="{name}">
            <div class="flex items-center">
                <vs-button :disabled="!name.preview_url" target="_blank" :href="name.preview_url" radius color="primary" type="flat" v-bind="$iconData('icon-eye', 'fi-rr-eye')"></vs-button>
                <p class="product-name font-medium truncate ml-4">{{name.name}}</p>
            </div>
        </template>
    </ds-table>
</template>

<script>
    export default {
        data () {
            return {
                heads: [
                    {name: 'global.id', key: 'id', sortKey: 'id', value: 'id', display: true, width: '40px'},
                    {name: 'global.Landings', key: 'name', sortKey: 'name', value: 'name', display: true},
                ]
            }
        },

        props: {
            data: {
                type: Object,
                require: true
            }
        },

        computed: {
            offersDetails () {
                return this.data.landings
            }
        }
    }
</script>
